import { render, staticRenderFns } from "./IssueCard.vue?vue&type=template&id=34105952&"
import script from "./IssueCard.vue?vue&type=script&lang=js&"
export * from "./IssueCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports